/**
 * z-index — for elements that portal to `document.body`, or otherwise render
 * as a fixed-position overlay competing in the SAME global stacking order as
 * other dismissible panels/backdrops: bottom sheets, modals, drawers,
 * dropdowns/tooltips, banners, toasts. Elements with their own local
 * stacking context (sticky headers, nav bars, in-page dropdowns, table
 * headers) don't need a value from this scale.
 *
 * `musicBarSurface` sits below plain `surface`: the Music Bar sheet can
 * mount for the first time in the same render as another sheet opens, so it
 * needs an explicit, always-lower value rather than relying on mount order.
 *
 * `dropdown` shares `surface`'s value: both portal types fully (un)mount on
 * open/close, so whichever opens later is always the later DOM sibling and
 * wins paint order — regardless of nesting direction.
 */
export const zIndex = {
  actionBar: 30, // floating in-page bars (save bar, bulk actions); every backdrop and surface covers them
  overlay: 40, // shared backdrop: modal / drawer / bottom-sheet / wizard
  musicBarSurface: 50, // lowest of the surface tier — anything else is allowed to cover it
  surface: 51, // generic surface: modals, drawer, action/download/playlist sheets, video sync
  dropdown: 51, // tooltips + floating-ui dropdowns/menus — shares `surface`, see above
  banner: 90, // app-wide banners that must beat every surface/modal (impersonation)
  toast: 99, // toast notifications — topmost within this scale
} as const;

/** app header (navbar) heights */
export const headerHeight = "3.125rem";
export const headerHeightMedium = "3.75rem";
